/* TODO : rename this file to render-helpers.tsx when we fulltime checkout-v3 */
import React, { ChangeEvent, ReactNode } from 'react';

import { Input, InputType } from 'pages/checkout/components/common/Input';
import { LabeledInput } from 'pages/checkout/components/common/LabeledInput/LabeledInput';
import { AutocompleteProps, MultiSelectProps, SingleSelectProps } from 'pages/common/components/Autocomplete/Autocomplete';

interface BaseInputConfig {
  id?: string;
  label: string;
  condition?: boolean;
  required?: boolean;
  isSensitive?: boolean;
  value: any;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string | boolean; // boolean allows us to do `condition && errorMessage`
  tooltip?: string;
  subtext?: string;
  endContent?: ReactNode;
  options?: any[];
  placeholderText?: string;
  gridSpan?: number;
  autoComplete?: string;
}

// Individual autocomplete input configurations
export type AutocompleteInputConfig = BaseInputConfig
  & { type: InputType.AUTOCOMPLETE_DROPDOWN; }
  & Partial<AutocompleteProps>;

export type SingleSelectInputConfig = BaseInputConfig
  & { type: InputType.SINGLE_SELECT_DROPDOWN; }
  & Partial<SingleSelectProps>;

export type MultiSelectInputConfig = BaseInputConfig
  & { type: InputType.MULTI_SELECT_DROPDOWN; }
  & Partial<MultiSelectProps>;

type StandardInputTypes = Exclude<
  InputType,
  InputType.AUTOCOMPLETE_DROPDOWN | InputType.SINGLE_SELECT_DROPDOWN | InputType.MULTI_SELECT_DROPDOWN
>;

// Non-autocomplete input types
type StandardInputConfig = BaseInputConfig
  & { type: StandardInputTypes; };

// Union of all input configurations
export type FormInputConfig =
  | AutocompleteInputConfig
  | SingleSelectInputConfig
  | MultiSelectInputConfig
  | StandardInputConfig;

const isAutocompleteConfig = (config: FormInputConfig) =>
  config.type === InputType.AUTOCOMPLETE_DROPDOWN
  || config.type === InputType.SINGLE_SELECT_DROPDOWN
  || config.type === InputType.MULTI_SELECT_DROPDOWN;

export const FormInputs = ({ inputConfigs }: { inputConfigs: FormInputConfig[]; }) => (
  <>
    {inputConfigs.filter((config) => config.condition === undefined || config.condition).map((config, index) => (
      <LabeledInput
        key={`${config.id || config.label}-${index}`}
        label={config.label}
        tooltip={config.tooltip}
        subtext={config.subtext}
        htmlFor={config.id}
        endContent={config.endContent}
      >
        <Input
          id={config.id}
          type={config.type}
          required={config.required}
          isSensitive={config.isSensitive ?? true}
          value={config.value}
          defaultSelected={config.value}
          onChange={config.onChange}
          errorMessage={typeof config.errorMessage === 'string' ? config.errorMessage : undefined}
          options={config.options}
          placeholderText={config.placeholderText}
          autoComplete={config.autoComplete}

          // Autocomplete props
          {...(isAutocompleteConfig(config) && {
            onSelect: config.onSelect,
            showSuffix: config.showSuffix,
            filterBy: config.filterBy,
            autoSelectOnBlur: config.autoSelectOnBlur,
          })}
        />
      </LabeledInput>
    ))}
  </>
);
export const commonBirthDateConfig: Pick<AutocompleteInputConfig, 'type' | 'placeholderText' | 'showSuffix' | 'filterBy' | 'autoSelectOnBlur'> = {
  type: InputType.AUTOCOMPLETE_DROPDOWN,
  placeholderText: 'Select',
  showSuffix: false,
  filterBy: ['name', 'id'],
  autoSelectOnBlur: true,
};
